import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'

import * as constants from './constants'
import * as actions from './actions'
import * as api from './api'

export const fetchGeolocationEpic = (action$) => {
  return action$
    .ofType(constants.FETCH_GEOLOCATION)
    .mergeMap(() => {
      return api.fetchGeolocation()
        .map((geolocation) => {
          return actions.fetchGeolocationSuccess(geolocation)
        })
        .startWith(actions.fetchGeolocationPending())
        .catch(error => Observable.of(actions.fetchGeolocationFailure(error)))
    })
}

export const epic = combineEpics(fetchGeolocationEpic)



// WEBPACK FOOTER //
// ./src/modules/geolocation/epic.js